import { handleActions } from 'redux-actions';
import update from 'react-addons-update';
import * as constants from '../constants/index';

const initialState = {
  isLoading: false,
  isLoggedIn: false,
  errors: {},
  success: {},
  step: 1,
  username: null,
  userType: true,
  type: null,
  inProgress: false,
  usernameHaveBeenChecked: false,
  isTokenSent: false,
  isTokenInvalid: false,
};

const setLoginRequest = (state) => update(state, {
  isLoading: { $set: true },
  isLoggedIn: { $set: false },
  errors: { $set: {} },
  success: { $set: {} },
});

const setLoginSuccess = (state, action) => update(state, {
  isLoading: { $set: false },
  isLoggedIn: { $set: action.payload.isLoggedIn },
});

const setLoginFailure = (state, action) => update(state, {
  isLoading: { $set: false },
  isLoggedIn: { $set: false },
  errors: { $set: action.payload.errors || action.payload.error },
  inProgress: { $set: false },
});

const setLogoutRequest = (state) => update(state, {
  isLoggedIn: { $set: false },
});

const setLogoutSuccess = (state, action) => update(state, {
  isLoading: { $set: false },
  isLoggedIn: { $set: false },
  success: { $set: action.payload.success },
});

const setLogoutFailure = (state, action) => update(state, {
  isLoading: { $set: false },
  isLoggedIn: { $set: false },
  success: { $set: action.payload.success },
});

const setLogoutIdle = (state) => update(state, {
  isLoading: { $set: false },
  isLoggedIn: { $set: false },
  errors: { $set: {} },
  success: { $set: {} },
});

const loginSetUserType = (state, action) => update(state, {
  isLoading: { $set: false },
  isLoggedIn: { $set: false },
  errors: { $set: {} },
  success: { $set: {} },
  userType: { $set: !action.payload.isAvailable },
  username: { $set: action.payload.username },
  type: { $set: action.payload.type },
  inProgress: { $set: false },
  usernameHaveBeenChecked: { $set: true },
});

const loginCheckUsernameRequest = (state, action) => update(state, {
  isLoading: { $set: false },
  isLoggedIn: { $set: false },
  errors: { $set: {} },
  success: { $set: {} },
  userType: { $set: !action.payload.isAvailable },
  type: { $set: null },
  inProgress: { $set: true },
});

const resetForm = () => initialState;

const fetchUserSelfSuccess = (state) => update(state, {
  isLoggedIn: { $set: true },
});

const fetchUserSelfFailure = (state) => update(state, {
  isLoggedIn: { $set: false },
});

const setAuthTokenSent = (state) => update(state, {
  isTokenSent: { $set: true },
});

const setAuthTokenFailure = (state) => update(state, {
  isTokenSent: { $set: true },
  isTokenInvalid: { $set: true },
});

export default handleActions({
  [constants.POST_LOGIN_REQUEST]: setLoginRequest,
  [constants.POST_LOGIN_SUCCESS]: setLoginSuccess,
  [constants.POST_LOGIN_FAILURE]: setLoginFailure,

  [constants.POST_LOGOUT_REQUEST]: setLogoutRequest,
  [constants.POST_LOGOUT_SUCCESS]: setLogoutSuccess,
  [constants.POST_LOGOUT_FAILURE]: setLogoutFailure,
  [constants.POST_LOGOUT_IDLE]: setLogoutIdle,

  [constants.LOGIN_SET_USERTYPE]: loginSetUserType,
  [constants.LOGIN_CHECK_USERNAME_REQUEST]: loginCheckUsernameRequest,
  [constants.LOGIN_RESET_FORM]: resetForm,

  [constants.FETCH_USER_SELF_SUCCSSS]: fetchUserSelfSuccess,
  [constants.FETCH_USER_SELF_FAILURE]: fetchUserSelfFailure,

  [constants.AUTH_TOKEN_SENT]: setAuthTokenSent,
  [constants.AUTH_TOKEN_FAILURE]: setAuthTokenFailure,
}, initialState);
